var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UpfrontContributionBase',[_c('ConfirmContributionPage',{attrs:{"schedule":_vm.schedule,"page":_vm.page,"updating":_vm.updating,"routeToModifySchedule":_vm.routeToModifySchedule,"isOnboarding":true},on:{"skip":_vm.onSkip}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }